import axios from "axios";
import { SERVER_URL } from "../../config/env";
import authHeader from "../utils/auth/auth-header";

class UserService {
  async getUserInfo(parameter, id, courseId) {
    try {
      const body = courseId ? { id, course_id: courseId } : { id };

      const response = await axios.post(
        `${SERVER_URL}husibuechapp/${parameter}`,
        body,
        { headers: authHeader() },
      );

      return response.data;
    } catch (error) {
      console.error("getUserInfo failed:", error);
      throw error;
    }
  }

  async updateUser(type, payload, userId) {
    try {
      const response = await axios.post(
        `${SERVER_URL}ksbhub/userupdate/${type}/${userId}`,
        payload,
        { headers: authHeader() },
      );

      return response.data;
    } catch (error) {
      console.error("updateUser failed:", error);
      throw error;
    }
  }

  async deleteUser(id) {
    try {
      const response = await axios.get(`${SERVER_URL}users/kill/${id}`, {
        headers: authHeader(),
      });

      return response.data;
    } catch (error) {
      console.error("deleteUser failed:", error);
      throw error;
    }
  }

  async requestPasswordReset(email) {
    try {
      const response = await axios.post(
        `${SERVER_URL}auth/request-password-reset`,
        { email },
      );

      return response.data;
    } catch (error) {
      console.error("requestPasswordReset failed:", error);
      throw error;
    }
  }

  async resetPassword(userId, token, password) {
    try {
      const response = await axios.post(`${SERVER_URL}auth/reset-password`, {
        userId,
        token,
        password,
      });

      return response.data;
    } catch (error) {
      console.error("resetPassword failed:", error);
      throw error;
    }
  }
}

const userService = new UserService(); // ✅ fixes eslint warning
export default userService;
